import $ from "jquery";
import {
  ChangeOfAddressType,
  ORDER_COMMENTS_ALERT,
  PAYMENT_METHOD_STRING,
  PONUMBER_ALLOW_DUPLICATE,
  PONUMBER_REQUIRED,
} from "../../constants";
import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { axiosInstance } from "../../axios/axiosInstance";
import { useAuth } from "../../Context/AuthContext";
import { useNoteAlert } from "../../Context/pleaseNote";
import { IsNumberKey, isNumberOnly, isValidNumber, normalizePath, poNumberStartWith } from "../../Layout/Common/common";

export const showAddressBook = () => {
  $("#checkout-list-address").fadeIn("slow");
  $("#checkout-edit-address").fadeIn("slow");
};

export const editAddressBookView = () => {};

export const convertAddressBookJson = (data) => {
  const { dropShippment, changeOfAddress } = ChangeOfAddressType;
  return {
    id: data.id ?? 0,
    shipTo: data.shipTo ?? "",
    address1: data.address1 ?? data.shipAddress1 ?? "",
    address2: data.address2 ?? data.shipAddress2 ?? "",
    address3: data.address3 ?? data.shipAddress3 ?? "",
    suburb: data.suburb ?? data.shipCity ?? "",
    state: data.state ?? data.shipState ?? "",
    postCode: data.postCode ?? data.shipZip ?? "",
    country: data.country ?? data.shipCountry ?? "Australia",
    phone: data.phone ?? data.shipPhone ?? "",
    attentionTo: data.attentionTo ?? data.shipAttention ?? "",
    deliveryInst: data.deliveryInst ?? "",
    isDropShipping: data.isDropShipping === true ? true : false,
    addressType: data.isDropShipping === true ? dropShippment : changeOfAddress,
    signRequired: data.signRequired ?? data.signatureRequired ?? true,
  };
};

export const convertAddressBookFormat = (data) => {
  const { dropShippment, changeOfAddress } = ChangeOfAddressType;
  return {
    id: data.id ?? 0,
    shipTo: data.shipTo ?? "",
    shipAddress1: data.address1 ?? "",
    shipAddress2: data.address2 ?? "",
    shipAddress3: data.address3 ?? "",
    shipCity: data.suburb ?? "",
    shipState: data.state ?? "",
    shipZip: data.postCode ?? "",
    shipCountry: data.country ?? "Australia",
    shipPhone: data.phone ?? "",
    shipAttention: data.attentionTo ?? "",
    deliveryInst: data.deliveryInst ?? "",
    isDropShipping: data.isDropShipping === true ? true : false,
    addressType: data.isDropShipping === true ? dropShippment : changeOfAddress,
    signatureRequired: data.signRequired ?? true,
  };
};
